<a
  *ngFor="
    let profileEntryResponse of activeTab ===
    RightBarCreatorsComponent.GAINERS.name
      ? globalVars.topGainerLeaderboard
      : activeTab === RightBarCreatorsComponent.DIAMONDS.name
      ? globalVars.topDiamondedLeaderboard
      : activeTab === RightBarCreatorsComponent.COMMUNITY.name
      ? globalVars.topCommunityProjectsLeaderboard
      : activeTab === RightBarCreatorsComponent.ALL_TIME.name
      ? globalVars.topCreatorsAllTimeLeaderboard
      : []
  "
  [routerLink]="[
    '/' + globalVars.RouteNames.USER_PREFIX,
    profileEntryResponse.Profile.Username
  ]"
  queryParamsHandling="merge"
  class="link--unstyled d-flex align-items-center text-grey5 fs-15px"
  [ngClass]="{
    'pb-5px':
      activeTab !== RightBarCreatorsComponent.COMMUNITY.name &&
      activeTab !== RightBarCreatorsComponent.ALL_TIME.name,
    'pb-15px':
      activeTab === RightBarCreatorsComponent.COMMUNITY.name ||
      activeTab === RightBarCreatorsComponent.ALL_TIME.name
  }"
>
  <div
    class="right-bar-creators-leaderboard__creator-avatar"
    [avatar]="profileEntryResponse.Profile.PublicKeyBase58Check"
  ></div>

  <div style="flex-grow: 1">
    <span>{{ profileEntryResponse.Profile.Username }}</span>
    <span
      *ngIf="
        profileEntryResponse.Profile.IsReserved &&
        !profileEntryResponse.Profile.IsVerified
      "
      class="d-inline-block ml-1 cursor-pointer lh-12px fc-muted"
      matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
      [matTooltip]="'This profile is reserved. Click to learn how to claim it.'"
    >
      <i class="far fa-clock fa-md"></i>
    </span>
    <span
      *ngIf="profileEntryResponse.Profile.IsVerified"
      (click)="tooltip.toggle()"
      class="ml-1 cursor-pointer text-primary"
      matTooltipClass="global__mat-tooltip global__mat-tooltip-font-size"
      [matTooltip]="'This account is verified'"
      #tooltip="matTooltip"
    >
      <i class="fas fa-check-circle fa-md"></i>
    </span>
  </div>

  <div class="d-flex flex-column" style="align-items: flex-end">
    <div
      class="fc-green"
      *ngIf="activeTab === RightBarCreatorsComponent.GAINERS.name"
    >
      +${{
        globalVars.abbreviateNumber(
          globalVars.nanosToUSDNumber(profileEntryResponse.DeSoLockedGained),
          2
        )
      }}
    </div>
    <div
      class="fc-blue"
      *ngIf="activeTab === RightBarCreatorsComponent.DIAMONDS.name"
    >
      {{
        globalVars.abbreviateNumber(profileEntryResponse.DiamondsReceived, 0)
      }}
      <i class="icon-diamond" style="margin-left: -10px"></i>
    </div>
    <div
      [ngClass]="{
        'text-grey7':
          activeTab !== RightBarCreatorsComponent.COMMUNITY.name &&
          activeTab !== RightBarCreatorsComponent.ALL_TIME.name,
        'text-grey5':
          activeTab === RightBarCreatorsComponent.COMMUNITY.name ||
          activeTab === RightBarCreatorsComponent.ALL_TIME.name
      }"
      [ngStyle]="{
        'font-size':
          activeTab === RightBarCreatorsComponent.COMMUNITY.name ||
          activeTab === RightBarCreatorsComponent.ALL_TIME.name
            ? '15px'
            : '10px'
      }"
    >
      ~{{
        globalVars.nanosToUSD(
          profileEntryResponse.Profile.CoinPriceDeSoNanos,
          2
        )
      }}
      <i
        class="fas fa-external-link-alt"
        *ngIf="activeTab === RightBarCreatorsComponent.COMMUNITY.name"
        [href]="profileEntryResponse.BithuntProject.website_url"
      ></i>
    </div>
  </div>
</a>
